module.exports = __webpack_public_path__ + "img/eco.38c21e64.png";